import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeftRight } from "lucide-react";
import TransferForm from "@/components/transfers/TransferForm";
import TransferHistory from "@/components/transfers/TransferHistory";

export default function StockTransfers() {
  const [transfers, setTransfers] = useState([]);
  const [tab, setTab] = useState("new");
  const load = () => api.get("/transfers").then((r) => setTransfers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="p-4 md:p-10 space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground mb-2 flex items-center gap-1.5">
          <ArrowLeftRight className="w-3 h-3" strokeWidth={1.5} /> Inventory · Between stores
        </div>
        <h1 className="font-display text-4xl tracking-tight" data-testid="transfers-title">Stock Transfers</h1>
        <p className="text-muted-foreground mt-2 text-sm">Move stock between Saint Herb stores. Each transfer takes stock out of one store and adds the same amount to the other in one step. Prices are not changed.</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="new" data-testid="transfers-tab-new">New transfer</TabsTrigger>
          <TabsTrigger value="history" data-testid="transfers-tab-history">Transfer history ({transfers.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="new"><TransferForm onDone={() => { load(); setTab("history"); }} /></TabsContent>
        <TabsContent value="history"><TransferHistory transfers={transfers} reload={load} /></TabsContent>
      </Tabs>
    </div>
  );
}
